/* eslint import/no-cycle: 0 */
import { YES, NO, DNK } from 'constants/values';
import { countryString } from '../validators/location';
import validate from './validateConfig';

/**
 * @returns {boolean | import('forms/shared/types').ValidateErrorContext[]}
 */
export const validateModel = (data = {}, model, options) => {
  const errors = options ? validate(data, model, options) : validate(data, model);

  if (!errors) { return true; }

  return errors;
};

export default validateModel;

// Misc helpers (might be moved later)

/** require Yes or No */
export const hasYesOrNo = {
  inclusion: { within: [YES, NO, DNK] },
};

/** check the value of an attribute.value
 *
 * @deprecated - Use optional chaining instead of this function.
 */
export const checkValue = (attribute, expected) => !!(attribute && attribute.value && attribute.value === expected);

export const checkValueIncluded = (attribute, expected) => attribute && attribute.value && expected.includes(attribute.value);

export const valueIsEmpty = (data = {}) => !data.value || validate.isEmpty(data.value);

export const nameIsEmpty = (data = {}) => {
  const {
    first, firstInitialOnly, middle, middleInitialOnly, last, suffix
  } = data;

  const fields = [first, firstInitialOnly, middle, middleInitialOnly, last, suffix];

  return fields.every((i) => i === false || validate.isEmpty(i));
};

export const dateIsEmpty = (data = {}) => {
  const { day, month, year } = data;
  const fields = [day, month, year];
  return fields.every((i) => validate.isEmpty(i));
};

export const dateNoDayIsEmpty = (data = {}) => {
  const { month, year } = data;
  const fields = [month, year];
  return fields.every((i) => validate.isEmpty(i));
};

/**
 * Determines if a location object is empty
 * @param {DeepSafePartial<import('forms/shared/types').LocationModel>} data
 * @returns {boolean}
 */
export const locationIsEmpty = (data = {}, ignoreCountry = false) => {
  const {
    street, country, city, state
  } = data;

  const countryIsEmpty = validate.isEmpty(country) || valueIsEmpty(country);
  const addressIsEmpty = validate.isEmpty(street) && validate.isEmpty(city) && validate.isEmpty(state);

  return ignoreCountry ? addressIsEmpty : addressIsEmpty && countryIsEmpty;
};

export const locationCityStateIsEmpty = (data = {}) => {
  const {
    city, state
  } = data;

  return validate.isEmpty(city) && validate.isEmpty(state);
};

export const locationCityCountryIsEmpty = (data = {}, checkInternational = false) => {
  const {
    country, city
  } = data;

  const countryIsEmpty = checkInternational
    ? countryString(country) === 'INTERNATIONAL' || validate.isEmpty(country) || valueIsEmpty(country)
    : validate.isEmpty(country) || valueIsEmpty(country);
  const addressIsEmpty = validate.isEmpty(city);

  return addressIsEmpty && countryIsEmpty;
};
